import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { LoadStore } from "./stores";
import ApplicationRouter from "./ApplicationRouter";
/**
 * App
 */
export default class App extends React.Component {
  static displayName = "App";
  static propTypes = {
    children: PropTypes.any,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param  {Object} props
   */
  constructor(props) {
    super(props);
    this.state = { appReady: false };
    _.bindAll(this, "onLoadStoreChange");
  }

  /**
   * THe load store changes, update state
   * @param  {Object} loadStoreState
   */
  onLoadStoreChange(loadStoreState) {
    if (loadStoreState.appStarted !== this.state.appReady) {
      this.setState({ appReady: !this.state.appReady });
    }
  }

  /**
   * @override
   */
  componentDidMount() {
    LoadStore.listen(this.onLoadStoreChange);
  }

  /**
   * @override
   */
  componentWillUnmount() {
    LoadStore.unlisten(this.onLoadStoreChange);
  }

  /**
   * @override
   */
  render() {
    return (
      <div className="App">{this.state.appReady && <ApplicationRouter />}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js